__turbopack_context__.v({
  "my_list_video_grid_item": "MyListVideoGridItem-module-scss-module__NmFP6q__my_list_video_grid_item",
  "my_list_video_kabob_menu": "MyListVideoGridItem-module-scss-module__NmFP6q__my_list_video_kabob_menu",
  "my_list_video_link": "MyListVideoGridItem-module-scss-module__NmFP6q__my_list_video_link",
  "my_list_video_remove_button": "MyListVideoGridItem-module-scss-module__NmFP6q__my_list_video_remove_button",
  "my_list_video_show_link": "MyListVideoGridItem-module-scss-module__NmFP6q__my_list_video_show_link",
});
